import { ButtonProps as MuiButtonProps } from '@mui/material';

export const colorVariants: Record<'tonal' | 'text', Pick<MuiButtonProps, 'variant' | 'color'>> = {
  tonal: {
    variant: 'contained',
    color: 'secondary',
  },
  text: {
    variant: 'text',
    color: 'secondary',
  },
};
